export enum NavigateType {
  DEFAULT = 'DEFAULT',
  OPEN_IN_NEW_TAB = 'OPEN_IN_NEW_TAB',
}

export type AuthRedirectData = {
  url: string;
  type: AuthRedirectType;
  enforceRedirectUrl?: boolean;
};

export enum AuthRedirectType {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  LOGIN_AFTER_FORCE_LOGOUT = 'LOGIN_AFTER_FORCE_LOGOUT',
}
